import React from "react";

// import {TransactionContext} from "../../../../../context";
// import {CustomBadges, TableLoading, TableNullData} from "../../../../../components";

import "./index.scss";
import {
  CustomBadges,
  CustomButton2,
  CustomIcon,
  CustomModal,
  TableNullData,
  UserInformation,
} from "../../../../../../components";
import utils from "../../../../../../utils";
import {
  GATEWAY,
  PAYER_TYPE,
  PAY_TYPE,
  TRANSACTION_REASON,
} from "../../../../../../values/dropdownItems";
import Context from "../../../../../../context";
import { useTranslation } from "react-i18next";
import convertGregorianToJalali from "../../../../../../utils/convertGregorianToJalali";

type Props = {
  data: any;
};

const Body = ({ data }: Props) => {
  const {
    requestDebt,
    setShowModal,
    showModal,
    setSelectedDebt,
    selectedWithdrawal,
    setSelectedWithdrawal,
  } = React.useContext(Context.payAdminToDriverContext);
  const [openInfoModal, setOpenInfoModal] = React.useState<boolean>(false);
  const docs = data?.data?.result?.docs;

  function onClickInfo() {
    setOpenInfoModal(!openInfoModal);
  }

  function onClickRow(index: number) {
    // setSelectedUserId(index);
    // setShowModal("SHOW");
  }

  const acceptHandler = (debt: any) => {
    setSelectedDebt(debt);
    setShowModal("ACCEPT_PAY_TO_DRIVER");
  };
  const cancleHandler = (debt: any) => {
    setSelectedDebt(debt);
    setShowModal("CANCLE_PAY_TO_DRIVER");
  };
  const sendToBankHandler = (debt: any) => {
    setSelectedDebt(debt);
    setShowModal("SEND_TO_BANK_PAY_TO_DRIVER");
  };

  const { t } = useTranslation();

  const checkHandler = (factorId: string) => {
    let newFactorList: string[] = [...selectedWithdrawal];
    if (selectedWithdrawal?.find((item: string) => item === factorId)) {
      newFactorList = selectedWithdrawal.filter(
        (item: string) => item !== factorId
      );
    } else {
      newFactorList = [...selectedWithdrawal, factorId];
    }
    setSelectedWithdrawal(newFactorList);
  };

  if (!docs || docs?.length <= 0) return <TableNullData />;
  return (
    <>
      <tbody id="withdrawal-body-container">
        {docs?.map((debt: any, index: number) => {
          let payerInfo: any = {};

          payerInfo = debt?.payerId;

          return (
            <tr
              key={`files-tr-${index}`}
              onClick={() => onClickRow(debt?.debtId?._id)}
            >
              <td onClick={onClickInfo}>
                <div className="table-index-number">
                  {requestDebt.page === 1 ? index + 1 : (requestDebt.page - 1) * 10 + index + 1}
                </div>
              </td>
              <td onClick={() => checkHandler(debt?._id)}>
                <input
                  id="checkmark"
                  type="checkbox"
                  name="checkmark"
                  checked={!!selectedWithdrawal?.find((item: string) => item === debt._id)}
                />
              </td>
              <td onClick={onClickInfo} className="table-text">
                {debt?.driver?.firstName + " " + debt?.driver?.lastName}
              </td>{" "}
              <td onClick={onClickInfo} className="table-text">
                {debt?.driver?.phoneNumber}
              </td>
              <td onClick={onClickInfo} className="table-text">
                {debt?.shabaId ? `IR ${debt?.shabaId}` : "-"}
              </td>
              <td onClick={onClickInfo} className="table-text">
                {utils.convertNumberToPrice(debt.amount)} {t("toman")}
              </td>{" "}
              <td onClick={onClickInfo} className="table-text">
                {convertGregorianToJalali({date:debt.createdAt,format:"HH:mm - jYYYY/jMM/jDD"}) }
              </td>{" "}
              <td onClick={onClickInfo} className="table-text">
                {t(debt.status)}
              </td>{" "}
              {/* <td onClick={onClickInfo} className="table-text">
                {debt.count}
              </td> */}
              <td onClick={onClickInfo} className="table-text">
                <div className="table-actions-buttons">
                  <CustomButton2
                    title={"تایید"}
                    type="info"
                    onClick={() => acceptHandler(debt)}
                  />
                  <CustomButton2
                    title={"رد"}
                    type="primary"
                    onClick={() => cancleHandler(debt)}
                  />
                  <CustomButton2
                    title={"ارسال به بانک"}
                    type="primary"
                    onClick={() => sendToBankHandler(debt)}
                  />
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </>
  );
};

export default Body;
